// extracted by mini-css-extract-plugin
export default {"root":"leftovers-list_root__VHHgV","filler":"leftovers-list_filler__O9GHO"};